import { Divider, MenuItem, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import Iconify from "src/components/Iconify";
import MenuPopover from "src/components/MenuPopover";
import { useAuth } from "src/hooks/useAuth";
import useLocales from "src/hooks/useLocales";
import { removeHeaderToken } from "src/services/config/apiClient";
import { PATH_AUTH } from "src/utils/paths";

import NameItem from "./NameItem";
import useGetMenuOptions from "./useGetMenuOptions";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

type Props = {
	isOpen: HTMLElement | null;
	onClose: () => void;
};

export default function AccountMenu({ isOpen, onClose }: Props) {
	const { translate } = useLocales();

	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const { signOut } = useAuth();
	const menuOptions = useGetMenuOptions();

	const handleLogout = () => {
		removeHeaderToken();
		signOut();
		queryClient.removeQueries();
		setTimeout(() => navigate({ to: PATH_AUTH.login, replace: true }), 300);
	};

	return (
		<MenuPopover
			anchorEl={isOpen}
			anchorOrigin={{
				vertical: "bottom",
				horizontal: "right"
			}}
			arrow='left-bottom'
			onClose={onClose}
			open={Boolean(isOpen)}
			transformOrigin={{
				vertical: "bottom",
				horizontal: "left"
			}}
		>
			<NameItem />
			<Divider sx={{ borderStyle: "dashed", my: 1 }} />
			{menuOptions.map((option) => (
				<MenuItem {...option} key={option.label} onClick={onClose}>
					<Iconify icon={option.icon} width={16} sx={{ mr: 1 }} />
					<Typography variant='body2'>{translate(option.label)}</Typography>
				</MenuItem>
			))}
			<Divider sx={{ borderStyle: "dashed" }} />
			<MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
				<Typography variant='subtitle2'>{translate("account_popover.logout")}</Typography>
			</MenuItem>
		</MenuPopover>
	);
}
